import { LapelError } from "../logger";
/**
 * @deprecated
 */ var poll = function(callback, interval, timeout) {
    return new Promise(function(resolve, reject) {
        var finished = false;
        var elapsedTime = 0;
        // Function to be called when polling is done
        var done = function(value) {
            finished = true;
            resolve(value);
        };
        // Function to be called when an error occurs during polling
        var error = function(err) {
            finished = true;
            reject(err);
        };
        // Helper function to execute polling
        var pollFunction = function() {
            elapsedTime += interval;
            try {
                callback(done, error);
                if (!finished && elapsedTime >= timeout) {
                    error(new LapelError("Poll timed out"));
                }
                if (!finished) {
                    var timer = setTimeout(pollFunction, interval);
                    if (timer.unref) timer.unref();
                }
            } catch (err) {
                error(err);
            }
        };
        // Call callback immediately before starting the timeout loop
        try {
            callback(done, error);
            if (!finished) {
                var initialTimer = setTimeout(pollFunction, interval);
                if (initialTimer.unref) initialTimer.unref();
            }
        } catch (err) {
            error(err);
        }
    });
};
export default poll;

//# sourceMappingURL=poll.js.map